import { useEffect, useContext } from 'react'
import { useLDClient } from 'launchdarkly-react-client-sdk'
import { AppState } from 'store/GlobalState'
import { User } from 'types/nonGenerated'
import { Vendor } from 'types/generated/graphql'

const createLaunchDarklyContext = (user: User, vendor: Vendor) => {
  return {
    kind: 'multi',
    user: {
      key: user.userId,
      email: user.email,
      name: user.username,
      admin: user.isAdmin,
    },
    vendor: {
      key: vendor.id,
      id: vendor.id,
      name: vendor.name,
      productTypes: vendor.productTypes,
    },
  }
}

export const useLaunchDarklyObserver = () => {
  const ldClient = useLDClient()
  const {
    settings: { user, vendor },
  } = useContext(AppState)

  useEffect(() => {
    if (!ldClient || !user || !vendor) {
      return
    }

    const newContext = createLaunchDarklyContext(user, vendor)

    ldClient.identify(newContext).catch((error) => {
      console.error('Failed to update LaunchDarkly context:', error)
    })
  }, [ldClient, user, vendor])

  return { ldClient, user, vendor }
}
